<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#F5F5F5" />
    <path
      d="M6.66675 13.3335H10.6667V17.3335"
      stroke="#767676"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.3333 10.6665H13.3333V6.6665"
      stroke="#767676"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 10.6667L17.9999 6"
      stroke="#767676"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 18.0002L10.6667 13.3335"
      stroke="#767676"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: "ShrinkIcon",
};
</script>
